/**
 * @tc/i18n — translation catalogues shared by the web app (react-i18next) and the
 * server (emails, PDFs). The full ES/EN catalogues are seeded from the prototype's
 * i18n files in TW-3434; for the foundation this establishes the package shape and
 * the locale metadata. Catalogues themselves ship as JSON via the `./locales/*`
 * subpath export, so consumers import e.g. `@tc/i18n/locales/en/common.json`.
 */

export const LOCALES = ["es", "en"] as const;
export type Locale = (typeof LOCALES)[number];

export const defaultLocale: Locale = "es";

export const namespaces = ["common"] as const;
export type Namespace = (typeof namespaces)[number];

/** Locale-aware Intl formatting helpers (date/number/currency), shared by web + server. */
export * from "./format";
